import React from "react";
import { Container, Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "./Home.css"; // Modern styling

const Home = () => {
  const navigate = useNavigate();

  return (
    <Box className="home">
      <Container maxWidth="md" className="hero">
        <Typography variant="h3" className="hero-title" gutterBottom>
          Welcome to <span className="highlight">CaRE Constructions</span>
        </Typography>
        <Typography variant="h6" className="hero-text">
          A division of <strong>Capital Re Energy and Laboratory Pvt Ltd</strong>, 
          committed to delivering <b>high-quality, durable, and sustainable homes</b>. 
          With in-house <b>material testing</b> and <b>soil analysis</b>, we ensure the 
          highest standards of construction—because your dream home deserves the best.
        </Typography>
        <Button
          variant="contained"
          className="cta-button"
          onClick={() => navigate("/services")}
        >
          Learn More
        </Button>
      </Container>
    </Box>
  );
};

export default Home;
